import styles from './BackgroundWaves.module.scss';

export function BackgroundWaves() {
    return <div className={styles.bgWaves} />;
}
